/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coral_Vivid_Lion_DozeInputs */

const en_coral_vivid_lion_doze = /** @type {(inputs: Coral_Vivid_Lion_DozeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting participation...`)
};

const de_coral_vivid_lion_doze = /** @type {(inputs: Coral_Vivid_Lion_DozeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilnahme wird gelöscht...`)
};

/**
* | output |
* | --- |
* | "Deleting participation..." |
*
* @param {Coral_Vivid_Lion_DozeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coral_vivid_lion_doze = /** @type {((inputs?: Coral_Vivid_Lion_DozeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coral_Vivid_Lion_DozeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coral_vivid_lion_doze(inputs)
	return de_coral_vivid_lion_doze(inputs)
});